import React from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { registerUser } from "./gateway";
import { contextLinesIntegration } from "@sentry/react";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";

export default function useSubmitRegistration() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: registerUser,
    onSuccess: (data, variables, context) => {
      enqueueSnackbar(t("Επιτυχής Εγγραφή"), { variant: "success" });

      navigate("/welcome/loginForm");
    },
  });
}
